define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-construct",
	"dojo/json",
	"csi",
	"csi/heading/_base",
	"csi/html",
	"csi/state/rootStore",
	"csi/types",
	"csi/utility/dateUtility",
	"csi/widget/InlineTextarea",
	"csi/widget/MessageDialog",
	"csi/xml",
	"./AttributeAction",
	"./StringTextarea"
], function(declare,lang,construct,json,csi,csiHeading,html,{ sessionStore },types,{getTimeInMilliseconds},InlineTextarea,MessageDialog,xml,AttributeAction,StringTextarea) {

	return declare(StringTextarea, {
		nTextareaLines: 10,

		canBeLarge: function(/*Context*/ctx, /*Heading*/h) {
			// summary: value could be large
			return ctx.getParam(csiHeading.CTX_LARGE_FORMAT) ? 2 : 1;
		},

		fromHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*InlineTextarea*/editNode) {
			// summary: strip '\r' characters from textarea values in IE
			var	cmt = this.inherited(arguments);
			if (!ctx) {
				return cmt;
			}

			var	value = this._getValue(ctx, h);

			// if no change was made, then just return previous string value
			if (cmt == this._getEditValue(ctx, h)) {
				return value;
			}

			var	comments = this._parseJson(value);
			if (comments instanceof Array) {
				// if reusing comment, then remove previous last comment
				if (this._reuseComment(comments.last())) {
					comments.pop();
				}
			} else {
				// if previously just a simple string, then replace with array
				comments = [];
			}

			// add new comment if non-empty - this allows for user to remove own comment on same day
			if (cmt) {
				comments.push({
					author: sessionStore.currentUser.$Name,
					date: types.getDateTime(),
					value: cmt
				});
			}

			return json.stringify({data:comments});
		},

		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: since multi-line comment string format will return a complicate json array style string,
			// it doesn't make sense to filter rich text - could end up filtering by tags
			return null;
		},

		toHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*Object*/params) {
			// summary: return Textarea widget
			if (params.value == null) {
				params.value = this._getEditValue(ctx, h);
			}

			return new InlineTextarea(params);
		},

		_commentToString: function(/*Object*/comment) {
			var commentString = "";
			if (comment.value) {
				commentString = comment.author + " " + types.formatTime(comment.date) + ": " + comment.value + "\n";
			}
			return commentString;
		},

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render value for attribute in HTML; if action exists, then add content
			// necessary to invoke edit mode (toHtmlDynamic); return false if no content
			var	value = this._getValue(ctx, h);
			if (value) {
				var comments = this._parseJson(value);

				if (comments instanceof Array) {
					var	cmt, s = "";

					for (var i = 0; i < comments.length; i++) {
						s += this._commentToString(comments[i]);
					}

					value = s;
				}

				html.multiLineText(refNode, value);
				return true;
			}

			return false;
		},

		toTooltip: function(/*Context*/ctx, /*Heading*/h, /*Tooltip*/tooltip) {
			// summary: generate tooltip for comments
			var	value = this._getValue(ctx, h);
			if (value) {
				tooltip.addAction(this._mixinTooltipAction(lang.mixin(new AttributeAction(), {
					m_id: "ResetComments",
					m_right: xml.RIGHT_WRITE,
					confirmAction: MessageDialog.BUTTON_RESET,
					classController: "csi.heading.StringCommentResetController"
				}), h));
			}
		},

		_getEditValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: if last comment was by same user on same day, then return it; otherwise return empty string
			// so new comment can be entered
			var	value = this._getValue(ctx, h);
			var	comments = this._parseJson(value);
			if (comments instanceof Array) {
				value = this._reuseComment(comments.last()) ? comments.last().value : "";
			}

			return value;
		},

		_parseJson: function(/*String*/value) {
			// summary: trying to convert the string value into a sorted array of comments
			if (value) {
				try {
					// support non-standard json
					value = value.replace(/{data:/, '{"data":');
					const cmtData = JSON.parse(value).data;
					cmtData.forEach((cmt) => {
						cmt.date = getTimeInMilliseconds(cmt.date);
					});
					return csi.sort(cmtData, "date");
				} catch(ex) {
					// return the original value if not valid json
				}
			}

			return value;
		},

		_reuseComment: function(/*Object?*/lastComment) {
			// summary: return true if last comment was by same user and on same day
			if (!lastComment) return false;

			const user = sessionStore.currentUser.$Name;
			const today = types.formatTime(types.getDateTime());

			return (user == lastComment.author) && (today == types.formatTime(lastComment.date));
		}
	});
});
